export enum Server {
    DEVELOPMENT = 'development',
    PRODUCTION = 'production'
}

export enum FileType {
    image = 'image',
    image_fr = 'image_fr',
    document = 'document',
    video = 'video',
    video_fr = 'video_fr',
    bg_image = 'bg_image' ,
    bg_image_fr = 'bg_image_fr'
  }

export enum ProposalType {
    APPROVAL = 0,
    CREATE_LOCKER = 1
}
  